
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaypointDeleteIec as ObiWaypointDeleteIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-waypoint-delete-iec.js';
 
 
 

 
 export const ObiWaypointDeleteIec = createComponent({
   react: React,
   tagName: 'obi-waypoint-delete-iec',
   elementClass: ObiWaypointDeleteIecElement,
   events: {
     
   }
  });
 
 